import template from './employee_groups_add.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';


// to do: fix search of recipients
class EmployeeGroupsAddViewModel
{
	constructor(dialog)
	{
		this.dialog = dialog;

		this.departments = ko.observableArray();
		this.employees = ko.observableArray();
		this.employee_group_id = ko.observable();
		this.employee_group = ko.observable();
		this.recipients = ko.observableArray([]);
		this.search_string = ko.observable('');
		this.selected_employee = ko.observable();
		this.emp_records = ko.observableArray([]);

		this.sorted_recipients = ko.pureComputed(() => {
			let entries = this.recipients().sort((a, b) => a.name >= b.name);

			// Unique check
			return entries.filter((value, index, array) => {
				return array.find(e => e.employee_id === value.employee_id) === value;
			});
		});

		this.selected_employee = ko.observable();

		this.selected_employee.subscribe((newValue) => {
			if (newValue != null)
			{
				if (!this.recipients().some(obj => obj.employee_id === newValue.employee_id))
				{
					this.recipients.push({
						employee_id: newValue.employee_id,
						name: `${newValue.firstname} ${newValue.surname} (${newValue.id_number})`
					});
				}
				else
					Grape.alerts.alert({type: 'error', message: tr('This employee is already added'),title: tr('Duplicate employee')});
			}
		});
	}

	close()
	{
		this.dialog.close(true);
	}

	remove_recipient(v, e)
	{
		let idx = this.recipients.indexOf(v);
		if (idx >= 0)
			this.recipients.splice(idx, 1);
	}

	async save_employee_group()
	{
		if (this.employee_group() == '' || this.employee_group() == null)
		{
			Grape.alerts.alert({type: 'error', title: tr('Invalid', 'Invalid'), message: tr('Group name cannot be empty')});
			return;
		}
		let data = {
			employee_group_id: this.employee_group_id(),
			employee_group: this.employee_group(),
			employees: this.sorted_recipients().map(r => r.employee_id)
		};

		if (data.employee_group_id === '')
			data.employee_group_id = null;

		let res = await Grape.fetches.postJSON('/admin/employee_group/save_employee_group', data);

		Utils.wrap_api_result(res, tr, async () => {
			await Grape.alerts.alert({type: 'success', title: tr('Success', 'Success'), message: tr('Successfully saved group.')});
			this.dialog.close();
		});
	}

	async add_employee()
	{
		if (this.search_string() && this.search_string().length > 0)
		{
			let employee = this.employees().find(e => e.name === this.search_string());
			if (employee)
			{
				let recipient = {
					employee_id: employee.employee_id,
					name: `${employee.firstname} ${employee.surname} (${employee.id_number})`
				};
				this.recipients.push(recipient);
				document.getElementById('txtRecipient').value = '';
			}
		}
	}

	async add_department_group(v, e)
	{
		let result = await Grape.fetches.getJSON('/api/record', {
			table: 'v_active_employees_department',
			schema: 'savanna',
			limit: 1000000,
			filter: [{ value: v.department_id, op: '=', field: 'department_id' }]
		});
		
		if (result.status != 'ERROR')
		{
			if (result.records != null || result.records != undefined)
			{
				for (let i = 0; i < result.records.length; i++)
				{
					if (!this.recipients().some(obj => obj.employee_id === result.records[i].employee_id))
					{
						result.records[i].name = result.records[i].firstname + ' ' +
						result.records[i].surname + ' (' + result.records[i].id_number + ')';
						
						this.recipients.push({
							employee_id: result.records[i].employee_id,
							name: result.records[i].name
						});
					}
				}
			}
		}
	}
}

class EmployeeGroupsAddPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new EmployeeGroupsAddViewModel(this);
		this.viewModel.employee_group(bindings.data.employee_group);
		this.viewModel.employee_group_id(bindings.data.employee_group_id);
	}

	async init()
	{
		await this.updateData();

		let depts = await Grape.cache.fetch('DepartmentCompanyList');
		let employees = await Grape.fetches.getJSON('/api/record', {
			schema: 'public',
			table: 'employee',
			limit: 1000000
		});

		// Add extra field to departments
		depts.forEach(d => { d.name = `${d.department} (${d.company})`; });
		this.viewModel.departments(depts);

		// Add extra field to employees
		employees.records.forEach(e => { e.name = `${e.firstname} ${e.surname} (${e.id_number})`; });
		this.viewModel.employees(employees.records);
	}

	async updateData()
	{
		if (this.bindings.data.employee_group_id === undefined)
		{
			this.viewModel.employee_group_id(0);
			this.viewModel.employee_group('');
			this.viewModel.recipients([]);
		}
		else
		{
			let groups_field = await Grape.fetches.getJSON('/api/record', {
				schema: 'savanna',
				table: 'v_employee_group',
				limit: 1000000,
				filter: [{
					field: 'employee_group_id',
					operand: '=',
					value: this.bindings.data.employee_group_id
				}]
			});

			if (groups_field.records[0].recipients)
			{
				let group = groups_field.records[0];

				let recipients = await Grape.fetches.getJSON('/api/record', {
					schema: 'public',
					table: 'employee',
					limit: 1000,
					filter: [{
						field: 'employee_id',
						operand: 'IN',
						value: group.recipients.map(r => r.employee_id)
					}]
				});

				group.recipients = recipients.records.map(e => {
					return {
						employee_id: e.employee_id,
						name: `${e.firstname} ${e.surname} (${e.id_number})`
					};
				});

				this.viewModel.employee_group_id(group.employee_group_id);
				this.viewModel.employee_group(group.employee_group);
				this.viewModel.recipients(group.recipients);
			}
		}
	}
}

export default {
	name: 'EmployeeGroupsAdd',
	dialog_class: EmployeeGroupsAddPage,
	template: template,
	template_filename: 'translation/dialogs/employee_groups_add',
	provider: 'ps'
};
